import { useAppSelector } from "../../../../app/hooks";
import { NotificationDialog } from "../notificationDialog/NotificationDialog";

export const NotificationWrapper = () => {
  const notification = useAppSelector((state) => state.message.notification);

  return (
    <NotificationDialog
      title={notification.title}
      contentText={notification.text}
      confirmText={notification.confirmText}
      links={notification.links}
      isOpen={!!notification.text}
    />
  );
};
